import { render, staticRenderFns } from "./ReferralChartNew.vue?vue&type=template&id=2e359a04&"
import script from "./ReferralChartNew.vue?vue&type=script&lang=js&"
export * from "./ReferralChartNew.vue?vue&type=script&lang=js&"
import style0 from "./ReferralChartNew.vue?vue&type=style&index=0&id=2e359a04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports